<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
    },
    classes: {
      type: String,
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    labelClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isToggled: false,
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    enterClicked() {
      this.$emit('enterButton')
    },
    openItems() {
      this.isToggled = true
    },
    closeItems() {
      this.isToggled = false
    },
  },
}
</script>

<template>
  <div class="mainInput" :class="classes">
    <span :class="labelClass" class="labelStyle" :style="title.length > 12 ? { whiteSpace: 'none' } : { whiteSpace: 'nowrap' }">{{ title }}</span>
    <b-form-input
      class="input___class d-flex align-items-center justify-content-between input__container colorInput"
      v-model="inputVal"
      @focus="openItems"
      @blur="closeItems"
      type="color"
      @keyup.enter="enterClicked"
      :disabled="disable"
    ></b-form-input>
    <i :class="{ down: isToggled, up: !isToggled }"> </i>
    <div></div>
  </div>
</template>

<style lang="scss" scoped>
.mainInput {
  display: flex;
  align-items: center;
}
input {
  width: 100%;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 0px 0px;
  box-sizing: border-box;
}
i {
  position: absolute;
  top: 10px;
  left: 10px;
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
.input__container {
  width: 100%;
  background: white;
  color: #74788d;
  background: #ffffff;
  border: 1px solid #ced4da;
  padding: 5px 10px;
  border-radius: 4px;
}
input:focus {
  outline: none;
}
input:focus::placeholder {
  color: transparent;
}
input::placeholder {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: #74788d;
}
.labelStyle {
  min-width: 90px;
  margin-left: 10px;
  display: table;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #444444;
  justify-content: flex-start;
  align-items: center;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
input[type='color'] {
  padding: 3px 3px 3px 85%;
  -webkit-appearance: none;
  width: 100% !important;
  height: 32px;
}
input[type='color']::-webkit-color-swatch-wrapper {
  padding: 0;
}
input[type='color']::-webkit-color-swatch {
  border: none;
  border-radius: 5px;
}
.input___class {
  border-radius: 4px;
}
</style>
